import React from "react";
import { connect } from "react-redux";
import { View, ViewTitle } from "../../shared/styled/view";
import Loader from "../../shared/icons/tat/loader";
import OptionSelectorSwitch from "../../shared/controls/option-selector-switch";
import FilterBarCompact from "../../shared/component/filter/filter-bar-compact";
import { getEntityItems, readEntities, readEntity } from "../../redux/api";
import { getCurrentCommandTabSelected, getTimeZone, groupFacilities, setCurrentCommandTabSelected, showSimpleFlashNotification } from "../../shared/utils";
import { TripTableView } from "./tables/trip-table-view";
import PaginatorControlled from "../../shared/controls/paginator-controlled";
import { cancelMultipleRequests, partialEntity } from "../../redux/api/actions";
import CatalogSelectionFooter from "../../shared/component/catalog-selection-footer";
import GenericDialog from "../../shared/dialog/generic-modal";
import { setOrderSeleted } from "../../redux/reducers/global-catalog.reducer";
import ShipmentReserveDialog from "../shipment/booking/shipment-reserve-dialog";
import { mapBookingAssemblyAvailability } from "../shipment/unassigned/utils";
import styled from "styled-components";
import ChangeDateModal from "../../shared/dialog/change-date-modal";

const TRIPTYPES = [
  { description: "FTL", value: 1 },
  { description: "LTL", value: 2 },
]

const session = JSON.parse(sessionStorage.getItem("orbinetwork_session"));
const companyData = session?.company?.id || 0;
const companyTypeId = session?.company?.type?.id || 0;

class TripsControlView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      tripType: 1,
      emails: [],
      buttonFilterName: "Aplicar",
      offset: 1,
      limit: 50,
      currentFacilities: [],
      getOrdersCalled: false,

      filter: {
        tripStatus: [],
        containerStatus: [],
        appointmentStatus: [],
        providers: [],
        transportClass: [],
        tripTags: [],
        orderTags: [],
        level: [],
        fromFacilities: [],
        toFacilities: [],
        urlFacilities: [],
        appointmentType: [],
        appointment: []
      },

      isAllTripsSelected: false,
      seed: Math.random(),
      tripsSelected: [],
      ordersSelected: [],
      tripFilter: null,
      codesNotFound: [],
      selectedAssembly: 0,
      selectedProvider: 0,
      bookTrip: null,
      showReserveDialog: false,
      showTransportsDialog: false,
      providers: [],
      errorMessage: null,
      modifyAppointmentLoading: null,
      modifyAppointmentUnloading: null,
      cancelAppointmentLoading: null,
      cancelAppointmentUnloading: null,
      finalizeTrip: null,
      finalizeOrder: null
    };
  }

  componentDidMount() {

    if (this.props.location.search.includes('facilities')) {
      const query = new URLSearchParams(this.props.location.search);

      let current_tab = getCurrentCommandTabSelected();

      if (current_tab && current_tab.third_tab) {
        this.state.tripType = current_tab.third_tab;
      }

      let codes = `${query.get('codes') || ''}`;

      this.setState({
        currentFacilities: `${query.get('facilities')}`.split(',').map(item => parseInt(item)),
        emails: codes === '' ? [] : codes.split(',').map( item => ({
          email: item, avatar: 'hide', avatarType: '', userId: null
        }))
      }, () => {

        this.props.loadTripFilterConfig({
          company_id: this.props.companyId
        }, {
          onSuccess: (response) => {
            this.state.tripFilter = response.trip_filter || null;
            this.loadItems();
          },
          onError: () => {
            this.loadItems();
          }
        });

      });
    }


    this.props.loadCompanyProviders({
      company_id: this.props.companyId,
      view: "booking",
    });

    this.props.loadCompanyTransportClasses({
      company_id: this.props.companyId,
      view: "grouped",
    });

    this.props.loadFacility({
      company_id: this.props.companyId
    })

    this.props.loadTagsTripCatalog({ company_id: this.props.companyId });
    this.props.loadTagsOrderCatalog({ company_id: this.props.companyId });
  }

  handleTabChange = (e) => {
    const { name, value } = e.target;
    setCurrentCommandTabSelected(null, null, value);

    this.setState({ [name]: value, offset: 1}, () => { this.loadItems() });
  };

  loadItems = () => {
    if (this.state.getOrdersCalled) {
      this.props.cancelMultipleRequests();
    }

    this.setState({ getOrdersCalled: true });

    let codes = this.state.emails.map( item => item.email);
    let params = {}

    if (codes.length > 0) {
      params = {
        company_id: this.props.companyId,
        transportType: this.state.tripType,
        facilities: this.state.filter.urlFacilities.length > 0 ? this.state.filter.urlFacilities : this.state.currentFacilities,
        tripStatus: '',
        containerStatus: '',
        appointmentStatus: '',
        providers: '',
        transportClass: '',
        tripTags: '',
        orderTags: '',
        level: '',
        fromFacilities: '',
        toFacilities: '',
        appointmentType: '',
        appointment: '',
        limit: this.state.limit,
        offset: this.state.offset,
        isMultipleCancels: true,
        tripCodes: codes,
        timezone: getTimeZone()
      };
    } else {
      params = {
        company_id: this.props.companyId,
        transportType: this.state.tripType,
        facilities: this.state.filter.urlFacilities.length > 0 ? this.state.filter.urlFacilities : this.state.currentFacilities,
        tripStatus: this.state.filter.tripStatus,
        containerStatus: this.state.filter.containerStatus,
        appointmentStatus: this.state.filter.appointmentStatus,
        providers: this.state.filter.providers,
        transportClass: this.state.filter.transportClass,
        tripTags: this.state.filter.tripTags,
        orderTags: this.state.filter.orderTags,
        level: this.state.filter.level,
        fromFacilities: this.state.filter.fromFacilities,
        toFacilities: this.state.filter.toFacilities,
        appointmentType: this.state.filter.appointmentType,
        appointment: this.state.filter.appointment[0] ? "".concat(this.state.filter.appointment[0].toISOString(), ",", this.state.filter.appointment[1] ? this.state.filter.appointment[1].toISOString() : this.state.filter.appointment[0].toISOString()) : "",
        limit: this.state.limit,
        offset: this.state.offset,
        isMultipleCancels: true,
        tripCodes: '',
        timezone: getTimeZone()
      };
    }

    this.props.loadTrips(params, {
      onSuccess: (response) => {

        if (codes.length > 0) {
          this.state.codesNotFound = [];
          codes.map(code => {
            let requisition_found = (response.results || []).find( order => order.signature.toLowerCase().includes(code.toLowerCase()) );

            if (!requisition_found) {
              this.state.codesNotFound.push(code);
            }
          });
        }

        this.setState({seed: Math.random()});
      }
    })

  }

  filterContent = () => {

    let appointments = [
      {
        id: "1",
        description: "Folios con cita de carga",
      },
      {
        id: "2",
        description: "Folios sin cita de carga",
      },
      {
        id: "3",
        description: "Folios con cita de descarga",
      },
      {
        id: "4",
        description: "Folios sin cita de descarga",
      }
    ];

    let level = [
      {
        id: "1",
        description: "1",
      },
      {
        id: "2",
        description: "2",
      },
      {
        id: "3",
        description: "3",
      },
      {
        id: "4",
        description: "4",
      },
      {
        id: "5",
        description: "5",
      }
    ];

    let type_date = [
      {
        id: "1",
        description: "Carga"
      },
      {
        id: "2",
        description: "Descarga"
      },
      {
        id: "3",
        description: "Creación de orden"
      },
      {
        id: "4",
        description: "Creación de embarque"
      }
    ];

    return(
      [
        {
          title: 'Estatus Viaje',
          items: this.props.tripStatuses,
          name: "tripStatus",
          listType: 5,
        },
        {
          title: "Estatus Equipo",
          items: this.props.containerStatusCatalog,
          name: "containerStatus",
          listType: 5,
        },
        {
          title: "Cita",
          items: appointments,
          name: "appointmentStatus",
          listType: 5,
        },
        {
          title: "Transportista",
          items: this.props.networkCompanies,
          name: "providers",
          listType: 5,
        },
        {
          title: "Clase",
          items: this.props.companyTransportClasses,
          name: "transportClass",
          listType: 5,
        },
        {
          title: "Etiqueta Viaje",
          items: this.props.companyTagsTrip,
          name: "tripTags",
          listType: 1,
        },
        {
          title: "Etiqueta Orden",
          items: this.props.companyTagsOrder,
          name: "orderTags",
          listType: 1,
        },
        {
          title: "Nivel de importancia",
          items: level,
          name: "level",
          listType: 5,
        },
        {
          title: "Origen",
          items: this.props.facilitiesByTag,
          name: "fromFacilities",
          listType: 5,
        },
        {
          title: "Destino",
          items: this.props.facilitiesByTag,
          name: "toFacilities",
          listType: 5,
        },
        {
          title: "Instalación",
          items: this.props.facilitiesByTag,
          name: "urlFacilities",
          listType: 5,
        },
        {
          title: "Fecha",
          name: "appointment",
          listType: 7,
          time: true
        },
        {
          title: "Tipo Fecha",
          items: type_date,
          name: "appointmentType",
          listType: 5,
        }
      ]
    );
  }

  handleEmailInput = (e) => {
    if (e) {
      switch (e.target.name) {
        case "inviteTags":
          let mails = e.target.value
            .map((i) => ({
              email: i.email,
              avatar: "hide",
              avatarType: "",
              userId: null,
            }));
          this.setState({ 
            emails: mails, 
            searchStr: e.target.value.map(e => e.email), 
            offset: 1,
            buttonFilterName: "Aplicar"
          }, this.loadItems);
          break;
        case "deleteTags":
          this.setState({ emails: [].concat(e.target.value), searchStr: e.target.value.map(e => e.email), offset: 1 }, this.loadItems);
          break;
        default:
      }
    }
  };

  getHeaderInfoSelection = () => { 
    return(
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#afc8ff'
        }}
      >
      </div>
    );
  }

  handleTripGridChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    switch(name) {
      case 'finalize-order':
        this.setState({finalizeOrder: value});
        break;
      case 'finalize-trip':
        this.setState({finalizeTrip: value});
        break;
      case 'cancel-appointment-unloading':
        this.setState({cancelAppointmentUnloading: value});
        break;
      case 'cancel-appointment-loading':
        this.setState({cancelAppointmentLoading: value});
        break;
      case 'modify-appointment-loading':
        this.setState({
          modifyAppointmentLoading: value
        });
        break;
      case 'modify-appointment-unloading':
        this.setState({
          modifyAppointmentUnloading: value
        });
        break; 
      case 'book-trip':
        this.setState({
          bookTrip: value
        })
        break;
      case 'trip_order_selected':
        this.props.setOrderDetail(value.order_code);
        this.props.history.push(`/company/controls/shipment/orderdetail/${value.trip_id}/`);
        break;
      case 'trip_selected':
        this.props.history.push(`/company/controls/shipment/orderdetail/${value.trip_id}/`);
        break;
      case 'trips_selected':
        this.setState({tripsSelected: value, ordersSelected: []});
        break;
      case 'orders_selected':
        this.setState({ordersSelected: value, tripsSelected: []});
        break;
      default:
        console.log('no action');
    }
  }

  getCount = () => {
    return this.props.tripsCount;
  }

  buildTripToBook = () => {
    if (this.state.bookTrip === null) return null;

    return({
      id: this.state.bookTrip.trip_id,
      hasProvider: this.state.bookTrip.fleet_provider !== null,
      isCompanyVerified: true,
      companyName: '',
      tripNumber: this.state.bookTrip.signature,
      tickets: this.state.bookTrip.orders_count,
      status: this.state.bookTrip.status?.description || '',
      class: null,
      assemble: null,
      tc: '',
      mainFacility: (this.state.bookTrip.orders || []).map( item => item.to_facility?.id || 0),
      tags: (this.state.bookTrip.tags || []).map( item => item.id || 0),
      is_unhooked: false,
      details: (this.state.bookTrip.orders || []).map( item => ({
        id: item.order_id,
        ticket: item.code,
        origin: {
          facilityId: item.from_facility.id,
          editable: true,
          logo: '',
          name: item.from_facility.name,
          date: '',
          location: '',
          isCompanyVerified: true
        },
        destination: {
          facilityId: item.to_facility.id,
          editable: true,
          logo: '',
          name: item.to_facility.name,
          date: '',
          location: '',
          isCompanyVerified: true
        },
      }))
    });
  }

  isOwnerUser = () => {
    if (['2', '3'].includes(`${companyTypeId}`)) { return true; } 
    return false;
  }

  getFacilityIdFromBookTrip = () => {
    if (this.state.bookTrip === null) return null;

    let facility_id = null;

    if ((this.state.bookTrip.orders || []).length > 0) {
      facility_id = this.state.bookTrip.orders[0].from_facility.id;
    }

    return facility_id;
  }

  loadAvailability = (booking: boolean = false) => {
    this.props.loadTripAvailability(
      {
        company_id: this.props.companyId,
        facility_id: this.getFacilityIdFromBookTrip(),
        trip_id: this.state.bookTrip.trip_id,
        view: booking ? "booking" : "trip",
      },
      {
        args: {
          company_id: this.props.companyId,
          facility_id: this.getFacilityIdFromBookTrip(),
          trip_id: this.state.currentTrip.id,
          view: booking ? "booking" : "trip",
        },
      }
    );
  };

  bookReservation = () => {
    if (this.props.isLoadingBookReservation) { return; }

    const params = {
      company_id: this.props.companyId,
      trip_id: this.state.bookTrip.trip_id,
      fleetproviderid: Number(this.state.selectedProvider),
      action: "set_assembly",
      primary_provider: this.state.selectedTransport || ''
    };
    if (this.state.selectedAssembly > 0) {
      params.assembly = this.state.selectedAssembly;
    } else if (this.state.selectedProvider > 0) {
    }
    this.props.bookReservation(params, {
      onSuccess: () => { 
        this.loadItems();
        this.manageReserveModal({ target: { name: "close-modals", value: "" } });
      },
      onError: (e) => {
        this.setState({
          errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
        })
      }
    });
  };

  manageReserveModal = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "open":
        this.setState({ showReserveDialog: true, currentTrip: value }, () =>
          this.loadAvailability(true)
        );
        break;
      case "close":
        this.setState({ showReserveDialog: false, currentTrip: {}, selectedTransport: null, bookTrip: null });
        break;
      case "close-modals":
        this.setState({ showReserveDialog: false, showTransportsDialog: false, selectedTransport: null, currentTrip: {}, selectedProvider: 0, bookTrip: null });
        break;
      case "save":

        if (!this.isOwnerUser()) {
          this.bookReservation();
        } else {
          let providersToShow = [];
        
          for (var i = 0; i < (this.props.providers || []).length; i++) {
            if (`${this.props.providers[i].fleet_provider.fleet_provider_id || 0}` === `${this.state.selectedProvider}`) {
              providersToShow = this.props.providers[i].primary_providers || [];
            }
          }

          if (providersToShow.length > 1) {
            this.setState({
              showTransportsDialog: true,
              showReserveDialog: false,  
              providers: providersToShow
            });
          } else if (providersToShow.length === 1) {
            this.setState({ selectedTransport: `${providersToShow[0].id}`}, () => {
              this.bookReservation();
            });
          } else {
            this.bookReservation();
          }
        }

        break;
      case "save-transports": 
        this.bookReservation();
        break;
      case "back-transports":
        this.setState({ showTransportsDialog: false, showReserveDialog: true });
        break;
      case "select-transport":
        this.setState({ selectedTransport: value });
        break;
      default:
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "selectedAssembly":
        this.setState({
          selectedProvider: value.provider,
          selectedAssembly: value.id,
        });
        break;
      case "selectedContract":
      case "selectedProvider":
        this.setState({
          selectedProvider: value,
          selectedAssembly: 0,
        });
        break;
      default:
        this.setState({ [name]: value });
    }
  };

  contractAvailability = () => {
    this.props.contractAvailability({
      company_id: this.props.companyId,
      facility_id: this.getFacilityIdFromBookTrip(),
    });
  };

  providerAvailability = () => {
    this.props.providerAvailability({
      company_id: this.props.companyId,
      view: "booking",
    });
  };

  render() {

    return (
      <View className="orders-control-view">

        {
          (this.props.isLoading) && 
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backgroundColor: "#00000080",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
              backdropFilter: "blur(3px)"
            }}
          >
            <div style={{display: "flex", alignItems: "center"}}>
              <Loader width="100px" height="100px"/>
              <div style={{color: "#fff", fontSize: "36px"}}>
                Cargando
              </div>
            </div>
            <div style={{color: "#fff", fontSize: "30px"}}>
              Si desea cancelar la consulta, presione ESC
            </div>
          </div>
        }

        <ViewTitle>
          <span>{'Control de Embarques'}</span>
        </ViewTitle>

        <div className="switches-container">

          <div/>

          <OptionSelectorSwitch
            value={this.state.tripType}
            name="tripType"
            onChange={this.handleTabChange}
            items={TRIPTYPES}
          />

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              marginBottom: 30
            }}
          > 
            <FilterBarCompact
              limit={350}
              searchStr={this.state.emails}
              searchAction={this.handleEmailInput}
              multiText={true}
              searchPlaceholder={"Buscar Viaje"}
              clearMultiText={() => {
                this.setState({ emails: [], searchStr: "" });
              }}
              filterAction={() => {
                if (this.state.buttonFilterName === "Aplicar") {
                  this.setState(
                    {
                      offset: 1,
                      buttonFilterName: "Restablecer"
                    },
                    () => { this.loadItems(); }
                  );
                } else {

                  this.setState({
                    offset: 1,
                    emails: [], 
                    searchStr: "",
                    filter: {
                      tripStatus: [],
                      containerStatus: [],
                      appointmentStatus: [],
                      providers: [],
                      transportClass: [],
                      tripTags: [],
                      orderTags: [],
                      level: [],
                      fromFacilities: [],
                      toFacilities: [],
                      urlFacilities: [],
                      appointmentType: [],
                      appointment: []
                    },
                    buttonFilterName: "Aplicar"
                  }, () => { this.loadItems(); })

                }
              }}
              buttonFilterName={this.state.buttonFilterName}
              content={this.filterContent()}
              onChange={(e) => {
                this.state.filter = {
                  ...this.state.filter,
                  [e.target.name]: e.target.value,
                };

                this.setState({
                  offset: 1,
                  buttonFilterName: "Aplicar"
                });
              }}
              selectedItems={this.state.filter}
            />
          </div>
        
        </div>

        <div className="content">

          <ResetButtonContainer>
            <div 
              className="reset-button"
              onClick={() => {
                
                this.setState({
                  tripFilter: {},
                  seed: Math.random()
                });

                this.props.updateTripFilterConfig({
                  company_id: this.props.companyId,
                  trip_filter: {}
                });

              }}
            >{'Reestablecer acomodo de columnas'}</div>
          </ResetButtonContainer>

          {
            this.getHeaderInfoSelection()
          }

          <TripTableView
            key={this.state.seed}
            rowData={this.props.tripsData || []}
            handleChange={this.handleTripGridChange}
            allSelected={this.state.isAllTripsSelected}
            configuration={this.state.tripFilter || {}}
            isLoading={this.props.isUpdatingFiltersLoading}
            currentCompany={this.props.company}
            setNewFilter={(new_filter) => {
              this.setState({
                tripFilter: new_filter
              });

              this.props.updateTripFilterConfig({
                company_id: this.props.companyId,
                trip_filter: new_filter
              });
            }}
          />

          <div style={{}}>
            <PaginatorControlled
              itemCount={this.getCount()}
              onChange={(e) => {
                this.setState({ [e.target.name]: e.target.value }, () => {
                  if (this.state.getOrdersCalled === true) {
                    this.loadItems();
                  }
                });
              }}
              limit={this.state.limit}
              offset={this.state.offset}
            />
          </div>

          {
            (this.state.tripsSelected.length > 0) &&
            <CatalogSelectionFooter
              key={`catalog-footer`}
              hideSelectAll={true}
              show={this.state.tripsSelected.length > 0}
              selectedElements={this.state.tripsSelected.length}
              selectAll={() => {
                this.setState({
                  isAllTripsSelected: true,
                  seed: Math.random()
                });
              }}
              actions={[
                {
                  description: "Cancelar Viajes",
                  f: () => { }
                },
                {
                  description: "Reservar Viajes",
                  f: () => { }
                },
                {
                  description: "Cancelar Reservaciones",
                  f: () => { }
                },
                {
                  description: "Finalizar Sin Datos",
                  f: () => { }
                },
                {
                  description: "Cerrar",
                  f: () => {
                    this.setState({seed: Math.random(), tripsSelected: [], isAllTripsSelected: false});
                  },
                }
              ]}
            />
          }

          {
            (this.state.ordersSelected.length > 0) &&
            <CatalogSelectionFooter
              key={`catalog-footer`}
              hideSelectAll={true}
              show={this.state.ordersSelected.length > 0}
              selectedElements={this.state.ordersSelected.length}
              selectAll={() => {}}
              actions={[
                {
                  description: "Cancelar Orden",
                  f: () => { }
                },
                {
                  description: "Finalizar Sin Datos",
                  f: () => { }
                },
                {
                  description: "Cerrar",
                  f: () => {
                    this.setState({seed: Math.random(), ordersSelected: []});
                  },
                }
              ]}
            />
          }

          {
            this.state.codesNotFound.length > 0 &&
            <GenericDialog
              open={this.state.codesNotFound.length > 0}
              title={'Viajes no encontradas:'}
              message={`${this.state.codesNotFound.join(', ')}`}
              acceptAction={() => this.setState({codesNotFound: []})}
              closeAction={() => this.setState({codesNotFound: []})}
            />
          }

          {
            this.state.errorMessage !== null &&
            <GenericDialog
              open={this.state.errorMessage !== null}
              title={'Error'}
              message={this.state.errorMessage}
              acceptAction={() => this.setState({errorMessage: null})}
              closeAction={() => this.setState({errorMessage: null})}
            />
          }

          {
            this.state.bookTrip !== null &&
            <ShipmentReserveDialog
              open={this.state.bookTrip !== null}
              isLoadingBooking={this.props.bookingLoading}
              onChange={this.manageReserveModal}
              trip={this.buildTripToBook()}
              assemblies={this.props.bookingAssemblyAvailability.map((a) => ({
                ...a,
                selectedAssembly: this.state.selectedAssembly,
                selected:
                  this.state.selectedAssembly.toString() === a.id.toString(),
                onChange: this.handleChange,
              }))}
              getContracts={this.contractAvailability}
              contracts={this.props.contracts.map((c) => ({
                ...c,
                id: c.fleet_provider.fleet_provider_id,
                selectedProvider: this.state.selectedProvider,
                selected:
                  this.state.selectedProvider.toString() === c.id.toString(),
                onChange: this.handleChange,
              }))}
              getProviders={this.providerAvailability}
              providers={this.props.providers.map((p) => ({
                ...p,
                id: p.fleet_provider.fleet_provider_id || "",
                selectedProvider: this.state.selectedProvider,
                selected:
                  this.state.selectedProvider.toString() === p.id.toString(),
                onChange: this.handleChange,
              }))}
              enabledAction={
                this.state.selectedProvider + this.state.selectedAssembly > 0
              }
            />
          }

          { this.state.modifyAppointmentLoading &&
            <ChangeDateModal
              editDate={this.state.modifyAppointmentLoading.date}
              open={this.state.modifyAppointmentLoading}
              onClose={() => {
                this.setState({
                  modifyAppointmentLoading: false
                });
              }}
              facilityId={this.state.modifyAppointmentLoading.facility_id}
              orderId={this.state.modifyAppointmentLoading.order_id}
              tripDetails={this.state.modifyAppointmentLoading.trip_details}
              data={this.state.modifyAppointmentLoading.data}
              date={new Date(this.state.modifyAppointmentLoading.date)}
              reasons={this.props.orderMotives.filter((m) => m.type === 2)}
              loadTrips={() => {
                this.loadItems();
              }}
            />
          }

          {
            this.state.modifyAppointmentUnloading &&
            <ChangeDateModal
              editDate={this.state.modifyAppointmentUnloading.date}
              open={this.state.modifyAppointmentUnloading}
              onClose={() => {
                this.setState({
                  modifyAppointmentUnloading: false
                });
              }}
              facilityId={this.state.modifyAppointmentUnloading.facility_id}
              orderId={this.state.modifyAppointmentUnloading.order_id}
              tripDetails={this.state.modifyAppointmentUnloading.trip_details}
              data={this.state.modifyAppointmentUnloading.data}
              date={new Date(this.state.modifyAppointmentUnloading.date)}
              reasons={this.props.orderMotives.filter((m) => m.type === 2)}
              loadTrips={() => {
                this.loadItems();
              }}
            />
          }

          {
          this.state.cancelAppointmentLoading &&
          <GenericDialog
            open={this.state.cancelAppointmentLoading !== null}
            title={'¿Estás seguro?'}
            message={`Esta acción cancelará la cita de carga de la orden ${this.state.cancelAppointmentLoading.code} y será irreversible`}
            isLoading={this.props.isCallOrderLoading}
            acceptAction={() => {

              let params = {
                company_id: this.props.companyId,
                action: 'cancel_appointment',
                view: 'load',
                id: this.state.cancelAppointmentLoading.order_id,
              };

              this.props.callOrderActions(params, {
                onSuccess: () => {

                  this.setState({cancelAppointmentLoading: null});
                  showSimpleFlashNotification('Se realizó el cambio con éxito', null);
                  this.loadItems();
                  
                },
                onError: (e) => {
                  this.setState({
                    errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
                  })
                }
              });

            }}
            closeAction={() => {
              this.setState({cancelAppointmentLoading: null})}
            }
          />
        }

        {
          this.state.finalizeOrder &&
          <GenericDialog
            open={this.state.finalizeOrder !== null}
            title={'¿Estás seguro?'}
            message={`Esta acción finalizará esta orden sin datos ${this.state.finalizeOrder.code || ''} y será irreversible`}
            isLoading={this.props.isCallOrderLoading}
            acceptAction={() => {

              let params = {
                action: "finalize_order",
                company_id: this.props.companyId,
                view: '',
                id: this.state.finalizeOrder.order_id
              }

              this.props.callOrderActions(params, {
                onSuccess: () => {

                  this.setState({finalizeOrder: null});
                  showSimpleFlashNotification('Se realizó el cambio con éxito', null);
                  this.loadItems();
                  
                },
                onError: (e) => {
                  this.setState({
                    errorMessage: e.response?.data?.errors || 'Ocurrió un error, intente de nuevo'
                  })
                }
              });

            }}
            closeAction={() => {
              this.setState({finalizeOrder: null})}
            }
          />
        }

        {
          this.state.finalizeTrip &&
          <GenericDialog
            open={this.state.finalizeTrip !== null}
            title={'¿Estás seguro?'}
            message={`Esta acción finalizará este viaje sin datos ${this.state.finalizeTrip.signature || ''} y será irreversible`}
            isLoading={this.props.isCallTripLoading}
            acceptAction={() => {

              let params = {
                action: "finalize_trip",
                company_id: this.props.companyId,
                trip_id: this.state.finalizeTrip.trip_id
              }

              this.props.callTripActions(params, {
                onSuccess: () => {

                  this.setState({finalizeTrip: null});
                  showSimpleFlashNotification('Se realizó el cambio con éxito', null);
                  this.loadItems();
                  
                },
                onError: (e) => {
                  this.setState({
                    errorMessage: e.response?.data?.errors || 'Ocurrió un error, intente de nuevo'
                  })
                }
              });

            }}
            closeAction={() => {
              this.setState({finalizeTrip: null})}
            }
          />
        }

        {
          this.state.cancelAppointmentUnloading &&
          <GenericDialog
            open={this.state.cancelAppointmentUnloading !== null}
            title={'¿Estás seguro?'}
            message={`Esta acción cancelará la cita de descarga de la orden ${this.state.cancelAppointmentUnloading.code} y será irreversible`}
            isLoading={this.props.isCallOrderLoading}
            acceptAction={() => {

              let params = {
                company_id: this.props.companyId,
                action: 'cancel_appointment',
                view: 'unload',
                id: this.state.cancelAppointmentUnloading.order_id,
              };

              this.props.callOrderActions(params, {
                onSuccess: () => {

                  this.setState({cancelAppointmentUnloading: null});
                  showSimpleFlashNotification('Se realizó el cambio con éxito', null);
                  this.loadItems();
                  
                },
                onError: (e) => {
                  this.setState({
                    errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
                  })
                }
              });

            }}
            closeAction={() => {
              this.setState({cancelAppointmentUnloading: null})}
            }
          />
        }

        </div>
      </View>
    );

  }

}

const mapStateToProps = (state) => {
  const companyId = state.globalCatalog.session.company.id;
  const tripStatuses = getEntityItems(state,"COMPANIES.CATALOGS.TRIPSTATUS").map((f) => ({description: f.description, id: f.id || 0}));
  const containerStatusCatalog = getEntityItems(state, "COMPANIES.CATALOGS.CONTAINERSTATUS");
  const companyTagsTrip = getEntityItems(state, "tagsTrips");
  const companyTagsOrder = getEntityItems(state, "tagsOrder");
  const companyTransportClasses = getEntityItems(state,"COMPANIES.TRANSPORTCLASS.FILTERS").map((f) => ({
    description: f.title,
    id: f.id,
    items: f.transport_classes.map((tc) => ({
      id: tc.id,
      description: tc.code,
    })),
  }));

  const companyProviders = getEntityItems(state, "COMPANIES.NETWORK");
  let ownCompanyId = state.globalCatalog.session.company.id;

  let ownCompanyType = (state.globalCatalog.session.company.type || { id: 0 }).id;
  let oppositeCompanyType = ownCompanyType === 1 ? 2 : 1;

  let networkCompanies =
    Array.isArray(state.companyReducer.networkApprovedInvitations.data) &&
    state.companyReducer.networkApprovedInvitations.data.reduce(
      (result, network) => {
        let id = companyProviders.find(
          (provider) => provider.id === network.id
        );
        if (network.from_companies.id === ownCompanyId) {
          if (network.to_companies.type === oppositeCompanyType) {
            result.push({
              id: String(id?.fleet_provider?.fleet_provider_id),

              description: network.to_companies_alias.concat(
                " - ",
                network.to_companies_code,
                " - ",
                network.to_companies.orbi_id
              ),
            });
          }
        } else {
          if (network.from_companies.type === oppositeCompanyType)
            result.push({
              // id: network.id,
              id: String(id?.fleet_provider?.fleet_provider_id),
              // description: network.from_companies.corporation_name,
              description: network.from_companies.orbi_id.concat(
                " - ",
                network.from_companies_alias,
                " - ",
                network.from_companies_code
              ),
            });
        }
        return result;
      },
      []
    );

  const companyFacilities = getEntityItems(state, "COMPANIES.FACILITIES");
  const facilitiesByTag = groupFacilities(companyFacilities);

  const isTripsCatalogLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.TRIPS.CATALOG2']?.status?.isFetching || false;
  const tripsData = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.TRIPS.CATALOG2")["results"] || []; 
  const tripsCount = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.TRIPS.CATALOG2")["count"] || 0;
  const isFiltersLoading = state?.api['COMPANIES.TRIPSCONTROL.FILTERCONFIGURATION']?.status?.isFetching || false;
  const isUpdatingFiltersLoading = state?.api['COMPANIES.TRIPSCONTROL.FILTERCONFIGURATION.UPDATE']?.status?.isFetching || false;
  const providers = getEntityItems(state, "COMPANIES.NETWORK");

  const tripAvailability = getEntityItems(state, "COMPANIES.FACILITIES.TRIPSCONTROL.BOOKING");
  const bookingAssemblyAvailability: Types.BookingAssemblyRow = tripAvailability
      .map(mapBookingAssemblyAvailability)
      .flat();
  const contracts = getEntityItems(state, "COMPANIES.FACILITIES.CONTRACTS");
  const isLoadingBookReservation = state?.api['COMPANIES.TRIPS']?.status?.isFetching || false;
  const bookingLoading = state.api["COMPANIES.TRIPS"]?.status?.isFetching || false;
  const isCallOrderLoading = state?.api['COMPANIES.ORDERS']?.status?.isFetching || false;
  const isCallTripLoading = state?.api['COMPANIES.TRIPS']?.status?.isFetching || false;

  const orderMotives = getEntityItems(state, "COMPANIES.CATALOGS.ORDERSMOTIVES")
    .map((o) =>
      o.submotives.map((s) => ({
        label: `${o.description} - ${s.description}`,
        value: s.id,
        type: s.type,
      }))
    )
    .flat();

  return{
    isCallTripLoading,
    isCallOrderLoading,
    orderMotives,
    isUpdatingFiltersLoading,
    tripsData,
    tripsCount,
    companyId,
    isLoading: isTripsCatalogLoading || isFiltersLoading,
    tripStatuses,
    containerStatusCatalog,
    networkCompanies,
    companyTransportClasses,
    companyTagsTrip,
    companyTagsOrder,
    facilitiesByTag,
    bookingAssemblyAvailability,
    contracts,
    providers,
    isLoadingBookReservation,
    bookingLoading,
    company: state.globalCatalog.session.company
  };
}

const mapDispatchToProps = (dispatch) => {
  dispatch(readEntities("COMPANIES.CATALOGS.TRIPSTATUS"));
  dispatch(readEntities("COMPANIES.CATALOGS.CONTAINERSTATUS"));
  dispatch(readEntities("COMPANIES.CATALOGS.ORDERSMOTIVES"));

  const loadTagsTripCatalog = (params = {}, opts = {}) =>
    dispatch(
      readEntities(
        "COMPANIES.ROUTES.TAGS",
        { ...params, type: "9" },
        { args: { ...params }, ...opts, alias: "tagsTrips" }
      )
    );
  const loadTagsOrderCatalog = (params = {}, opts = {}) =>
    dispatch(
      readEntities(
        "COMPANIES.ROUTES.TAGS",
        { ...params, type: "7" },
        { args: { ...params }, ...opts, alias: "tagsOrder" }
      )
    );

  return{
    contractAvailability: (params, options) => dispatch(readEntities("COMPANIES.FACILITIES.CONTRACTS", params, options)),
    providerAvailability: (params, options) => dispatch(readEntities("COMPANIES.NETWORK", params, options)),
    cancelMultipleRequests: () => dispatch(cancelMultipleRequests()),
    loadTrips: (params, opt) => dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.TRIPS.CATALOG2", params, opt)),
    loadCompanyProviders: (params, opts) => dispatch(readEntities("COMPANIES.NETWORK", params, opts)),
    loadCompanyTransportClasses: (params, opts) => dispatch(readEntities("COMPANIES.TRANSPORTCLASS.FILTERS", params, opts)),
    loadFacility: (params, opts) => dispatch(readEntities("COMPANIES.FACILITIES", params, opts)),
    loadTagsTripCatalog,
    loadTagsOrderCatalog,
    loadTripFilterConfig: (params, opt) => dispatch(readEntity("COMPANIES.TRIPSCONTROL.FILTERCONFIGURATION", params, opt)),
    updateTripFilterConfig: (params, opts) => dispatch(partialEntity("COMPANIES.TRIPSCONTROL.FILTERCONFIGURATION.UPDATE", params, opts)),
    setOrderDetail: (payload) => dispatch(setOrderSeleted(payload)),
    bookReservation: (params, options) => dispatch(partialEntity("COMPANIES.TRIPS", params, options)),
    callOrderActions: (params, opts) => dispatch(partialEntity("COMPANIES.ORDERS", params, opts)),
    callTripActions: (params, options) => dispatch(partialEntity("COMPANIES.TRIPS", params, options)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsControlView);

const ResetButtonContainer = styled.div`
  width: 100%;
  display: flex;
  height: 25px;
  justify-content: right;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;

  & .reset-button {
    cursor: pointer;
    font-size: 16px;
    text-decoration: underline;
    color: white;

    &:hover {
      font-size: 18px;
    }
  }
`;